export const POST_BUSINESS_HOME_REQUEST = "POST_BUSINESS_HOME_REQUEST"
export const POST_BUSINESS_HOME_SUCCESS = "POST_BUSINESS_HOME_SUCCESS"
export const POST_BUSINESS_HOME_FAILURE = "POST_BUSINESS_HOME_FAILURE"
